/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

export const SHOW_MESSAGE = 'SHOW_MESSAGE';

export function showMessage(payload) {
    // sample payload = {show: false, messageKey: 'order_details_save_success', type: 'warning }
    // messageKey and types can found from APP_CONSTANT.js under MESSAGES and MESSAGE_TYPES
    return {type: SHOW_MESSAGE, payload: payload};
}

export const HIDE_MESSAGE = 'HIDE_MESSAGE';

export function hideMessage() {
    return {type: HIDE_MESSAGE};
}


// WEBPACK FOOTER //
// ./src/_actions/message.actions.js